import { initLogger, logger } from "@skypointcloud/logger/react";
import type { ReactPlugin } from "@skypointcloud/logger/react";

const result = initLogger({
  appName: "skypoint-skysupport-client",
  environment: import.meta.env.MODE,
  appInsightsConnectionString: import.meta.env.VITE_APP_INSIGHTS_CONNECTION_STRING,
});

const reactPlugin = result.reactPlugin as ReactPlugin | undefined;
export { logger };
